import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import * as artifactActions from '~/artifact/actions';
type ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeaderProps = {
  actions: object;
  manager: string;
  artifactState: object;
  text: string;
  activeManager?: string;
};
class ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader extends React.Component<
  ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeaderProps,
  {}
> {
  updateComponentPackageManager = () => {
    this.props.actions.updateComponentPackageManager(this.props.manager, 'signatures');
  };
  render() {
    let text = this.props.text,
      manager = this.props.manager,
      activeManager = this.props.activeManager,
      isActive = manager === activeManager,
      containerClasses,
      textClasses;
    containerClasses = classNames({
      grid: true,
      'bo-b--5': true,
      'pb--': true,
      'cursor--pointer': true,
      'border-color--transparent': !isActive,
      'border-color--primary': isActive,
      'flex flex--justify-content--center': true,
    });
    textClasses = classNames({
      'font--h6': true,
      'text--bold': isActive,
    });
    return (
      <div className={containerClasses} onClick={this.updateComponentPackageManager}>
        <span className={textClasses}>{text}</span>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentSignaturesComponentVersionPackageManagerHeader);
